/* eslint-disable wrap-iife */
/* eslint-disable import/prefer-default-export */
/* eslint-env browser */
const copyToClipboard = (str) => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

// planket fra https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f

const isElementWithClassNameInEventPath = (event, className) => {
  let found = false;
  const path = event.path || (event.composedPath && event.composedPath());
  path.forEach((p) => {
    if (p.classList) {
      if (p.classList.contains(className)) {
        found = true;
      }
    }
  });
  return found;
};

const getBaseFontSize = () => parseInt(window.getComputedStyle(document.documentElement).fontSize.replace('px', ''), 10);
const setMetaThemeColor = () => {
  const body = document.querySelector('body');
  if (body) {
    const bgColor = window.getComputedStyle(body).getPropertyValue('--color-background');
    const existingMeta = document.querySelector('meta[name="theme-color"]');
    if (existingMeta) {
      existingMeta.content = bgColor;
    } else {
      const meta = document.createElement('meta');
      meta.name = 'theme-color';
      meta.content = bgColor;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }
};

export {
  copyToClipboard,
  isElementWithClassNameInEventPath,
  getBaseFontSize,
  setMetaThemeColor,
};
